import "@/App.css";
import { LangProvider } from "./lib/lang";
import { SmoothScroll } from "./components/site/SmoothScroll";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Services } from "./components/site/Services";
import { Portfolio } from "./components/site/Portfolio";
import { Reel } from "./components/site/Reel";
import { Process } from "./components/site/Process";
import { Materials } from "./components/site/Materials";
import { Order } from "./components/site/Order";
import { Faq } from "./components/site/Faq";
import { Footer } from "./components/site/Footer";

function App() {
  return (
    <LangProvider>
      <SmoothScroll />
      <div className="grain" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Portfolio />
        <Reel />
        <Process />
        <Materials />
        <Order />
        <Faq />
      </main>
      <Footer />
    </LangProvider>
  );
}

export default App;
